import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App.jsx'
import { PBCC_PREMIUM, HUSTLER, IS_GOLF_ELITE } from './config/siteMode.js'
import CLUB from './config/club.js'
import { startAutoUpdate } from './lib/autoUpdate.js'
import './styles.css'

// Golf Elite — the platform default brand. A single root class flips every
// --ge-* token (styles.css) to the Golf Elite navy/blue palette, and the brand
// chrome (favicon, tab title, mobile theme-color) is overridden at runtime so
// index.html can keep shipping the PBCC defaults untouched for the PBCC build.
if (IS_GOLF_ELITE) {
  document.documentElement.classList.add('golf-elite')
  document.title = CLUB.name
  try {
    document.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]').forEach((l) => { l.href = CLUB.logo })
    const tc = document.querySelector('meta[name="theme-color"]')
    if (tc) tc.setAttribute('content', CLUB.primaryColor)
  } catch { /* ignore */ }
}

// Premium admin theme is TEST-ONLY (pbcc-tourney-test). Gate the whole cream/gold
// CSS layer behind a single html class so it can never reach the club, even on a
// FOURBALL rebuild of THEIRS. All premium rules in styles.css are scoped under it.
// Never on the Golf Elite build (it may reuse a premium DB for preview).
if (PBCC_PREMIUM && !IS_GOLF_ELITE) document.documentElement.classList.add('pbcc-premium')
// Golf Hustler reskin: a single root class re-themes the shared premium surfaces
// (dark-green → near-black, gold hairlines → Hustler gold) via the block at the
// end of styles.css. Only the golfhustler build sets it.
if (HUSTLER) document.documentElement.classList.add('hustler')

// TEST: capture the PWA install prompt so the qualify finish screen can offer a
// one-tap "Add to Home Screen" (Android). iOS uses the Share-sheet steps. No
// service worker is registered (kept off to avoid stale caches).
if (PBCC_PREMIUM && typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    window.__pbccInstallPrompt = e
    try { window.dispatchEvent(new Event('pbcc-install-available')) } catch { /* ignore */ }
  })
}

// Bumping APP_VERSION in vite.config.js changes this string at build time and
// therefore changes the bundle hash. Logged so you can see which version is
// running in DevTools console.
// eslint-disable-next-line no-console
console.log('[CompleteTourneyLive] v' + (typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev'))

// Auto-update: force a reload whenever a newer build is deployed, so no device is
// ever trapped on a stale cache. Runs alongside the no-store index.html + the
// self-destructing SW cleanup (see index.html) for defence in depth.
startAutoUpdate()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
